module.exports = __webpack_public_path__ + "img/img50.98812823.jpg";